import { render, staticRenderFns } from "./AnalyticsCitizenshipChart.vue?vue&type=template&id=19b4a254"
import script from "./AnalyticsCitizenshipChart.vue?vue&type=script&lang=js"
export * from "./AnalyticsCitizenshipChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports